import React from 'react';
// import './css/Footer.css';
import '../css/index.css';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-ctn">
        <p>LifeGPA &copy;2019</p>
      </div>
    </div>
  )
}

export default Footer;